// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3SPV9","col":"styles_col__3YfJp","fulfillmentStatus":"styles_fulfillmentStatus__x0s0T","emailCol":"styles_emailCol__2UZgo"};